import script from "./QCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./QCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./QCheckbox.vue?vue&type=style&index=0&id=3027091b&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3027091b"]])

export default __exports__